import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSellingAttributesUI from './PDPSellingAttributesUI';
import PDPSellingAttributesPlaceholder from './PDPSellingAttributesPlaceholder';
const PDPSellingAttributesInner = () => {
  const $ = _c(12);
  const {
    loading: basicDetailsLoading,
    data: basicDetails
  } = usePDPBasicDetails();
  if (basicDetailsLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PDPSellingAttributesUI loading={true} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== basicDetails) {
    t0 = basicDetails ?? {};
    $[1] = basicDetails;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    custom_properties: t1,
    type: t2
  } = t0;
  let t3;
  if ($[3] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    selling_attributes
  } = t3;
  let t4;
  if ($[5] !== t2) {
    t4 = t2 === undefined ? {} : t2;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    name
  } = t4;
  if (!selling_attributes?.length) {
    return null;
  }
  let t5;
  if ($[7] !== selling_attributes) {
    t5 = selling_attributes || [];
    $[7] = selling_attributes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== name || $[10] !== t5) {
    t6 = <PDPSellingAttributesUI attributes={t5} productType={name} />;
    $[9] = name;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
const PDPSellingAttributes = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPSellingAttributesPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPSellingAttributesInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPSellingAttributes;